import { Controller } from "stimulus";
import OpSlider from "~/scripts/components/opSlider/opSlider";

const CLASS_SELECTED = "is-selected";

export default class extends Controller {
    resizeTimer = null;
    contentWidth;
    indexHeight;
    titleHeight;
    currentIndex = 0;

    static targets = [
        "slider",
        "frame",
        "list",
        "slide",
        "left",
        "right",
        "indexList",
        "index",
        "titleList",
        "title",
        "contentList",
        "contentSlide"
    ];

    initialize() {
        this.onLoad = this.onLoad.bind(this);
        this.onResize = this.onResize.bind(this);
        this.select = this.select.bind(this);
        this.tick = this.tick.bind(this);
    }

    connect() {
        this.length = this.slideTargets.length;
        window.addEventListener("load", this.onLoad);
        window.addEventListener("resize", this.onResize);
    }

    onResize() {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(this.tick, 250);
    }

    tick() {
        this.contentWidth = this.contentSlideTargets[0].offsetWidth;
        this.indexHeight = this.indexTargets[0].offsetHeight;
        this.titleHeight = this.titleTargets[0].offsetHeight;
        this.select(this.currentIndex);
    }

    onLoad() {
        this.tick();

        let config = {
            slider: this.sliderTarget,
            frame: this.frameTarget,
            list: this.listTarget,
            slides: this.slideTargets,
            nextItems: this.hasRightTarget ? [this.rightTarget] : null,
            prevItems: this.hasLeftTarget ? [this.leftTarget] : null,
            onSelect: this.select,
            animationAllowed: false,
            mode: {}
        };

        if (window.innerWidth > 768) {
            config.dragAllowed = false;
        } else {
            config.dragAllowed = true;
        }

        // this.select(0);
        this.slider = new OpSlider(config);
    }

    select(index) {
        this.currentIndex = index;
        this.contentListTarget.style.transform = `translate3d(${index * this.contentWidth}px, 0, 0)`;
        this.indexListTarget.style.transform = `translateY(-${index * this.indexHeight}px)`;
        this.titleListTarget.style.transform = `translateY(-${index * this.titleHeight}px)`;
        // console.log(index);

        for (let i = 0; i < this.length; i++) {
            this.indexTargets[i].classList.remove(CLASS_SELECTED);
            this.titleTargets[i].classList.remove(CLASS_SELECTED);
            this.contentSlideTargets[i].classList.remove(CLASS_SELECTED);
        }

        this.indexTargets[index].classList.add(CLASS_SELECTED);
        this.titleTargets[index].classList.add(CLASS_SELECTED);
        this.contentSlideTargets[index].classList.add(CLASS_SELECTED);
    }
}



// WEBPACK FOOTER //
// ./public/assets/scripts/controllers/home-slider_controller.js